import type {
  OfflineModeReachBound,
  OfflineModeReachChannel,
  OfflineModeReachField,
  OfflineModeReachLimit,
  OfflineModeReachQuality,
} from 'redux-stores/offlineMode';

export const NOT_MEASURED_LIMIT_CODES: readonly string[] = ['live_registry_unavailable'];

export const CHANNELS_FIELD = 'channels';

export const KNOWN_BOUNDS: readonly OfflineModeReachBound[] = ['at_least', 'at_most', 'exact'];

export function boundFor(
  quality: OfflineModeReachQuality,
  field: OfflineModeReachField
): OfflineModeReachBound {
  const stated = quality.bounds[field];
  if (stated) return KNOWN_BOUNDS.includes(stated) ? stated : 'at_least';

  const trustworthy =
    field === 'total' ? quality.denominatorTrustworthy : quality.numeratorTrustworthy;
  if (trustworthy) return 'exact';
  return field === 'not_reachable' ? 'at_most' : 'at_least';
}

export function limitsAffecting(
  quality: OfflineModeReachQuality,
  field: string
): OfflineModeReachLimit[] {
  return quality.limits.filter((limit) => limit.affects.includes(field));
}

export function notMeasuredLimit(
  quality: OfflineModeReachQuality,
  field: OfflineModeReachField
): OfflineModeReachLimit | undefined {
  return limitsAffecting(quality, field).find((limit) =>
    NOT_MEASURED_LIMIT_CODES.includes(limit.code)
  );
}

export const isQualityClean = (quality: OfflineModeReachQuality): boolean =>
  quality.level === 'complete';

export const anyChannelAvailable = (channels: OfflineModeReachChannel[]): boolean =>
  channels.some((channel) => channel.available);

export const formatCount = (value: number): string => value.toLocaleString('en-US');
